/**
 * Created by pajicv on 9/29/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import Dashboard from './Dashboard';
import { spinnerWhileLoading } from '../utils/components';

export const populates = [{
    child: 'manager',
    root: 'projects'
},{
    child: 'worker',
    root: 'projects'
}, {
    child: 'co-manager',
    root: 'projects'
}];

const enhance = compose(
  connect(
    (state) => {
      const encodedEmail = window.btoa(state.firebase.auth.email);
      return ({
        auth: state.firebase.auth,
        userProjects: populate(state.firebase, `users/${encodedEmail}/projects`, populates)
      });
    }
  ),
  firebaseConnect((props, store) => {
      const encodedEmail = window.btoa(store.getState().firebase.auth.email);
      return [{ path: `users/${encodedEmail}/projects`, populates }];
  }),
    spinnerWhileLoading(['userProjects'])
);

export default enhance(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/Dashboard.enhancer.js